<template>
  <div class="sectionContainer music-player" id="profile-music">
    <div class="crow">
      <div class="chalf">

        <div id="jplayer-audio-container" class="jp-audio" role="application" aria-label="media player">
          <div class="jp-playlist jp-playlist_custom">
            <div class="playlist_inner">

              <div class="playlist_left">
                <h6 class="list-sep">Catalog</h6>
                <!-- Nav pills -->
                <ul id="playlist_ops" class="nav nav-pills" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" data-toggle="pill" href="#tracks">Tracks </a>
                  </li>
                </ul>

              </div>

              <div id="style-1" class="playlist_wrapper">
                <form class="search_input">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                    <input type="text" @input="searchMusics" v-model="searchQuery" class="form-control" placeholder="Search...">
                  </div>
                </form>
                <div class="tab-content">
                  <div id="tracks" class="tab-pane active"><br>
                    <ul>
                      <li>&nbsp;</li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
            <!-- <ul>
              <li>&nbsp;</li>
            </ul> -->
          </div>
          <div class="jp-type-playlist">
            <div class="jp-gui jp-interface flex-wrap ">

              <div class="jp-now-playing flex-item">
                <div class="toggle-playlist-c">
                  <i class="fa fa-angle-up" aria-hidden="true"></i>
                </div>
                <div id="jplayer-audio" class="jp-jplayer"></div>
                <div class="jp-title jp-track-name"></div>
                <span class="jp-artist"></span>
              </div>

              <div class="jp-controls flex-item">
                <button class="jp-previous jp-btn" role="button" tabindex="0"><i class="fa fa-backward"></i></button>
                <button class="jp-play jp-btn" role="button" tabindex="0"><i class="fa fa-play"></i></button>
                <button class="jp-next jp-btn" role="button" tabindex="0"><i class="fa fa-forward"></i></button>
              </div>
              <div class="jp-progress-container flex-item">
                <div class="jp-time-holder"><span class="jp-current-time" role="timer"
                    aria-label="time">00:00</span><span class="jp-duration" role="timer"
                    aria-label="duration">03:29</span></div>
                <div class="jp-progress">
                  <div class="jp-seek-bar">
                    <div class="jp-play-bar"></div>
                  </div>
                </div>
              </div>

              <div class="jp-volume-controls flex-item">
                <div class="jp-toggles">
                  <button class="jp-shuffle jp-btn" role="button" tabindex="0"><i class="fa fa-random"></i></button>
                </div>
                <button class="jp-mute" role="button" tabindex="0"><i class="fa fa-volume-up"></i></button>
                <div class="jp-volume-bar">
                  <div class="jp-volume-bar-value" style="width: 80%;">
                    <div class="bullet"></div>
                  </div>
                </div>
              </div>

              <div class="player-options w15 btns no-livestream" id="dkplayer-track-options">
                <a href="#" target="_blank"
                  class="no-ajaxy removed spotify-action spot-btn-1Q11ARVhgnMdhsMheqjNLk connect-btn">
                  <i class="fa fa-spotify" aria-hidden="true"></i>
                </a>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
/* eslint-disable new-cap */
import YoutubeMusic from '@/models/YoutubeMusic'
export default {
  name: 'MusicPlayer',
  data () {
    return {
      jplayer: null,
      searchQuery: '',
      youtubeMusics: []
    }
  },
  mounted () {
    let jplayer = document.createElement('script')
    jplayer.setAttribute('src', '/static/js/jquery.jplayer.js')
    document.head.appendChild(jplayer)

    let jplayerPlaylist = document.createElement('script')
    jplayerPlaylist.setAttribute('src', '/static/js/jplayer.playlist.js')
    document.head.appendChild(jplayerPlaylist)

    this.fetchYoutubeMusics()
  },
  methods: {
    fetchYoutubeMusics () {
      this.$store
        .dispatch('fetchYoutubeMusics')
        .then((resp) => {
          this.youtubeMusics = []
          resp.data.youtubeMusics.forEach(music => {
            this.youtubeMusics.push(new YoutubeMusic(music))
          })
          this.initJPlayer()
        })
        .catch((err) => this.$helper.catchHandler(err))
    },

    searchMusics () {
      var filter, musicDetail, trackDesc, trackTitle, txtValue
      filter = this.searchQuery.toUpperCase()
      musicDetail = $('.jp-playlist .music_detail')
      musicDetail.each(function () {
        trackDesc = $(this).find('.track-desc')
        trackTitle = trackDesc.find('.trackTitle')
        console.log(trackTitle.html())
        if (trackTitle) {
          txtValue = trackTitle.html()
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            $(this).show()
          } else {
            $(this).hide()
          }
        }
      })
    },

    initJPlayer () {
      var that = this
      // eslint-disable-next-line no-undef
      this.jplayer = new jPlayerPlaylist({
        jPlayer: '#jplayer-audio',
        cssSelectorAncestor: '#jplayer-audio-container'
      }, this.youtubeMusics, {
        swfPath: 'src/swf/',
        solution: 'html, flash',
        supplied: 'mp3',
        preload: 'auto',
        wmode: 'window',
        useStateClassSkin: true,
        autoBlur: false,
        smoothPlayBar: true,
        keyEnabled: true,
        stop: function (e) {
          $('.toggle-play').removeClass('active')
          $('.waves').fadeOut()
        },
        pause: function (e) {
          $('.toggle-play').removeClass('active')
          $('.waves').fadeOut()
          that.$store.dispatch('updateIsPlayingStatus', false)
          // that.$store.getters.jPlayer.isPlaying = false
        },
        play: function (e) {
          $('.toggle-play').addClass('active')
          $('.waves').fadeIn()
          that.$store.dispatch('updateIsPlayingStatus', true)
          // that.$store.getters.jPlayer.isPlaying = true
        },
        ready: function (e) {
          $('.toggle-list').bind('click', function () {
            if (!$('body').hasClass('active')) {
              $('body').addClass('active')
            } else {
              $('body').removeClass('active')
            }
          })
          $(window).on('load', function () {
            $('#jp_video').jPlayer('play')
          })
          $('.toggle-play').on('click', function () {
            if (!$('.jp-audio').hasClass('jp-state-playing')) {
              $('#jp_video').jPlayer('play')
            } else {
              $('#jp_video').jPlayer('stop')
            }
          })
          $('.toggle-playlist-c').click(function () {
            $('.jp-playlist').slideToggle('fast')
          })
          setTimeout(() => {
            $('.toggler_ellipse').click(function () {
              $(this).parent().find('.extra-opts_1').slideToggle()
            })
          }, 500)
        }
      })
      this.$store.dispatch('updateJPlayer', this.jplayer)
      // this.$jPlayer.add(this.youtubeMusics[0], true)
      // this.$jPlayer.addPlaylist(this.youtubeMusics)
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MusicPlayer.vue